import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'header',
    name: 'page.smart-attachment.col-header',
  },
];
